
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import PropTypes from 'prop-types';

function LiveGameH2HChart (props) {
    return Template.default.apply({props}); //eslint-disable-line no-undef
}

LiveGameH2HChart.propTypes = {
    stats: PropTypes.object.isRequired,
    sportAlias: PropTypes.string.isRequired
};

export default LiveGameH2HChart;